import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import React from "react";
import {APP_FOOTER_HEIGHT} from "../../actions/ui";

export default function AppFooter() {
  return(
    <Box
      sx={{
        justifyContent: "center",
        display: "flex",
        height: APP_FOOTER_HEIGHT,
        alignItems: 'center',
        fontSize: 13,
        alignContent: 'center',
      }}
    >
      <Link
        target="_blank"
        href='https://busnearby.co.il/static/accessibility_busnearby.html'
        underline="hover">הצהרת נגישות</Link>
      <div style={{marginInline: 8}}>•</div>
      <Link
        target="_blank"
        href='https://busnearby.co.il/static/busnearby-tos-privacy-policy.html'
        underline="hover">תנאי שימוש ומדיניות הפרטיות</Link>
    </Box>
  )
}